// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function use1(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function use2(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function use3(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function use4(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function use5(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function use6(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function use7(effect, deps) {
  let mounted = React.useRef(false);
  React.useEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

function useLayout1(effect, deps) {
  let mounted = React.useRef(false);
  React.useLayoutEffect(() => {
    if (mounted.current) {
      return effect();
    } else {
      mounted.current = true;
      return;
    }
  }, deps);
}

export {
  use1,
  use2,
  use3,
  use4,
  use5,
  use6,
  use7,
  useLayout1,
}
/* react Not a pure module */
